// import React, { Fragment } from 'react';
// import Navbar from '../../components/Navbar'
// import Hero from '../../components/hero';
// import About from '../../components/about';
// import ProjectSection from '../../components/Projects';
// // import ServiceSection from '../../components/Services';
// import FunFact from '../../components/FunFact';
// // import TeamSection from '../../components/TeamSection';
// import Testimonial from '../../components/Testimonial';
// import BlogSection from '../../components/BlogSection';
// import Footer from '../../components/footer';
// import Scrollbar from '../../components/scrollbar'
// import Logo from '../../images/logo.png'
// // import maakResidence1 from '../../images/projects/maak-residence-1.jpg';
// // import aizelTower2 from '../../images/projects/aizel-warsan-2.jpg';
// import UpcomingProjects from '../../components/UpcomingProjects';
// import MAAKLOGO from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-24-16.jpg';



// // import Logo from '../../images/logo/maak-dream-logo.png'
// // import maakResidence1 from '../../images/projects/maak-residence-1.jpg';

// const HomePage = () => {
//     return (
//         <Fragment>
//             <Hero />
//             <Navbar Logo={Logo} hclass={'header-style-1'} />
//             <div className="content-below-slider">
//                 <About abimg={MAAKLOGO} />
//                 <UpcomingProjects />
//                 {/* <ProjectSection /> */}
//                 {/* <ServiceSection/> */}
//                 <FunFact />
//                 {/* <TeamSection/> */}
//                 <Testimonial />
//                 <BlogSection />
//                 <Footer />
//             </div>
//             <Scrollbar />
//         </Fragment>
//     )
// };
// export default HomePage;
























// import React, { Fragment, useState, useEffect } from 'react';
// import Navbar from '../../components/Navbar';
// import Hero from '../../components/hero';
// import About from '../../components/about';
// import ProjectSection from '../../components/Projects';
// import FunFact from '../../components/FunFact';
// import Testimonial from '../../components/Testimonial';
// import BlogSection from '../../components/BlogSection';
// import Footer from '../../components/footer';
// import Scrollbar from '../../components/scrollbar';
// import Logo from '../../images/logo.png';
// import UpcomingProjects from '../../components/UpcomingProjects';
// import MAAKLOGO from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-24-16.jpg';
// import { getHero } from '../../api/Home'; // your API function

// const HomePage = () => {
//     const [heroData, setHeroData] = useState(null);

//     useEffect(() => {
//         const fetchHero = async () => {
//             try {
//                 const data = await getHero();
//                 setHeroData(data);
//             } catch (err) {
//                 console.error("Failed to fetch hero data:", err);
//             }
//         };
//         fetchHero();
//     }, []);

//     if (!heroData) return null; // or a loader

//     return (
//         <Fragment>
//             <Hero heroData={heroData} />
//             <Navbar Logo={Logo} hclass={'header-style-1'} />
//             <div className="content-below-slider">
//                 <About abimg={MAAKLOGO} />
//                 <UpcomingProjects />
//                 <FunFact />
//                 <Testimonial />
//                 <BlogSection />
//                 <Footer />
//             </div>
//             <Scrollbar />
//         </Fragment>
//     );
// };

// export default HomePage;

























// import React, { Fragment, useState, useEffect } from 'react';
// import Navbar from '../../components/Navbar';
// import Hero from '../../components/hero';
// import About from '../../components/about';
// import ProjectSection from '../../components/Projects';
// import FunFact from '../../components/FunFact';
// import Testimonial from '../../components/Testimonial';
// import BlogSection from '../../components/BlogSection';
// import Footer from '../../components/footer';
// import Scrollbar from '../../components/scrollbar';
// import Logo from '../../images/logo.png';
// import UpcomingProjects from '../../components/UpcomingProjects';
// import MAAKLOGO from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-24-16.jpg';
// import { getHero } from '../../api/Home';
// import IntroVideo from '../../images/video/MaaksonsbridgeMaakdream.mp4';

// // New VideoIntro Component
// const VideoIntro = ({ videoSrc, onVideoEnd }) => {
//     const videoRef = React.useRef(null);
//     const [hasSound, setHasSound] = useState(false);

//     useEffect(() => {
//         const videoEl = videoRef.current;

//         const handleEnded = () => {
//             onVideoEnd();
//         };

//         if (videoEl) {
//             // Try to play with sound first
//             videoEl.play().then(() => {
//                 setHasSound(true);
//             }).catch(err => {
//                 console.log("Autoplay with sound blocked, trying muted:", err);
//                 // If blocked, mute and try again
//                 videoEl.muted = true;
//                 videoEl.play().catch(e => console.log("Video play error:", e));
//             });
            
//             videoEl.addEventListener("ended", handleEnded);
//         }

//         return () => {
//             if (videoEl) videoEl.removeEventListener("ended", handleEnded);
//         };
//     }, [onVideoEnd]);

//     const handleUnmute = () => {
//         if (videoRef.current) {
//             videoRef.current.muted = false;
//             setHasSound(true);
//         }
//     };

//     return (
//         <div 
//             className="video-intro-wrapper" 
//             style={{ 
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw", 
//                 height: "100vh", 
//                 overflow: "hidden",
//                 zIndex: 9999,
//                 backgroundColor: "#000"
//             }}
//         >
//             <video
//                 ref={videoRef}
//                 src={videoSrc}
//                 type="video/mp4"
//                 style={{ 
//                     position: "absolute",
//                     top: "50%",
//                     left: "50%",
//                     minWidth: "100%",
//                     minHeight: "100%",
//                     width: "auto",
//                     height: "auto",
//                     transform: "translate(-50%, -50%)",
//                     objectFit: "cover"
//                 }}
//                 playsInline
//                 preload="auto"
//             />
//             {!hasSound && (
//                 <button
//                     onClick={handleUnmute}
//                     style={{
//                         position: "absolute",
//                         bottom: "30px",
//                         right: "30px",
//                         padding: "15px 30px",
//                         backgroundColor: "rgba(255, 255, 255, 0.9)",
//                         border: "none",
//                         borderRadius: "5px",
//                         cursor: "pointer",
//                         fontSize: "16px",
//                         fontWeight: "bold",
//                         zIndex: 10000,
//                         boxShadow: "0 4px 6px rgba(0,0,0,0.3)"
//                     }}
//                 >
//                     🔊 Enable Sound
//                 </button>
//             )}
//         </div>
//     );
// };

// const HomePage = () => {
//     const [heroData, setHeroData] = useState(null);
//     const [showHome, setShowHome] = useState(() => {
//         // Check if video has already been shown in this session
//         const hasSeenVideo = sessionStorage.getItem('hasSeenIntroVideo');
//         return hasSeenVideo === 'true';
//     });

//     useEffect(() => {
//         const fetchHero = async () => {
//             try {
//                 const data = await getHero();
//                 setHeroData(data);
//             } catch (err) {
//                 console.error("Failed to fetch hero data:", err);
//             }
//         };
//         fetchHero();
//     }, []);

//     const handleVideoEnd = () => {
//         // Mark video as seen for this session
//         sessionStorage.setItem('hasSeenIntroVideo', 'true');
//         setShowHome(true);
//     };

//     if (!heroData) return null;

//     // Show video first, then home content
//     if (!showHome) {
//         return <VideoIntro videoSrc={IntroVideo} onVideoEnd={handleVideoEnd} />;
//     }

//     return (
//         <Fragment>
//             <Hero heroData={heroData} />
//             <Navbar Logo={Logo} hclass={'header-style-1'} />
//             <div className="content-below-slider">
//                 <About abimg={MAAKLOGO} />
//                 <UpcomingProjects />
//                 <FunFact />
//                 <Testimonial />
//                 <BlogSection />
//                 <Footer />
//             </div>
//             <Scrollbar />
//         </Fragment>
//     );
// };

// export default HomePage;




















import React, { Fragment, useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Hero from '../../components/hero';
import About from '../../components/about';
import ProjectSection from '../../components/Projects';
import FunFact from '../../components/FunFact';
import Testimonial from '../../components/Testimonial';
import BlogSection from '../../components/BlogSection';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.png';
import UpcomingProjects from '../../components/UpcomingProjects';
import MAAKLOGO from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-24-16.jpg';
import { getHero } from '../../api/Home';
// import IntroVideo from '../../images/video/MaaksonsbridgeMaakdream.mp4';

const IntroVideo = "https://res.cloudinary.com/dtdppef0w/video/upload/v1766052963/MaaksonsbridgeMaakdream_t6suc8.mp4"

// New VideoIntro Component
// const VideoIntro = ({ videoSrc, onVideoEnd }) => {
//     const videoRef = React.useRef(null);
//     const [isMuted, setIsMuted] = useState(true);
//     const [showSkip, setShowSkip] = useState(false);

//     useEffect(() => {
//         const videoEl = videoRef.current;

//         const handleEnded = () => {
//             onVideoEnd();
//         };

//         if (videoEl) {
//             // Try to play with sound first
//             videoEl.play().then(() => {
//                 setIsMuted(false);
//                 videoEl.muted = false;
//             }).catch(err => {
//                 console.log("Autoplay with sound blocked, trying muted:", err);
//                 // If blocked, mute and try again
//                 videoEl.muted = true;
//                 setIsMuted(true);
//                 videoEl.play().catch(e => console.log("Video play error:", e));
//             });
            
//             videoEl.addEventListener("ended", handleEnded);
//         }

//         // Show close button after 2 seconds
//         const skipTimer = setTimeout(() => {
//             setShowSkip(true);
//         });

//         return () => {
//             if (videoEl) videoEl.removeEventListener("ended", handleEnded);
//             clearTimeout(skipTimer);
//         };
//     }, [onVideoEnd]);

//     const toggleMute = () => {
//         if (videoRef.current) {
//             videoRef.current.muted = !isMuted;
//             setIsMuted(!isMuted);
//         }
//     };

//     const handleClose = () => {
//         onVideoEnd();
//     };

//     return (
//         <div 
//             className="video-intro-wrapper" 
//             style={{ 
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw", 
//                 height: "100vh", 
//                 backgroundColor: "rgba(0, 0, 0, 0.85)",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 zIndex: 9999,
//             }}
//         >
//             <div style={{
//                 position: "relative",
//                 width: "80%",
//                 maxWidth: "900px",
//                 aspectRatio: "16/9",
//                 backgroundColor: "#000",
//                 borderRadius: "12px",
//                 overflow: "hidden",
//                 boxShadow: "0 10px 40px rgba(0,0,0,0.5)"
//             }}>
//                 <video
//                     ref={videoRef}
//                     src={videoSrc}
//                     type="video/mp4"
//                     style={{ 
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "contain"
//                     }}
//                     playsInline
//                     preload="auto"
//                 />
                
//                 {/* Close button (X) - shows after 2 seconds */}
//                 {showSkip && (
//                     <button
//                         onClick={handleClose}
//                         style={{
//                             position: "absolute",
//                             top: "15px",
//                             right: "15px",
//                             width: "40px",
//                             height: "40px",
//                             backgroundColor: "rgba(255, 255, 255, 0.9)",
//                             border: "none",
//                             borderRadius: "50%",
//                             cursor: "pointer",
//                             fontSize: "24px",
//                             fontWeight: "bold",
//                             zIndex: 10000,
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
//                             transition: "all 0.3s ease",
//                             color: "#333"
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.backgroundColor = "rgba(255, 255, 255, 1)";
//                             e.target.style.transform = "scale(1.1) rotate(90deg)";
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
//                             e.target.style.transform = "scale(1) rotate(0deg)";
//                         }}
//                     >
//                         ×
//                     </button>
//                 )}

//                 {/* Sound toggle button - always visible */}
//                 <button
//                     onClick={toggleMute}
//                     style={{
//                         position: "absolute",
//                         bottom: "20px",
//                         right: "20px",
//                         padding: "10px 20px",
//                         backgroundColor: "rgba(255, 255, 255, 0.9)",
//                         border: "none",
//                         borderRadius: "25px",
//                         cursor: "pointer",
//                         fontSize: "14px",
//                         fontWeight: "600",
//                         zIndex: 10000,
//                         boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
//                         transition: "all 0.3s ease"
//                     }}
//                     onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "rgba(255, 255, 255, 1)";
//                         e.target.style.transform = "scale(1.05)";
//                     }}
//                     onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
//                         e.target.style.transform = "scale(1)";
//                     }}
//                 >
//                     {isMuted ? "Enable Sound" : "Disable Sound"}
//                 </button>
//             </div>
//         </div>
//     );
// };
const VideoIntro = ({ videoSrc, onVideoEnd }) => {
    const videoRef = React.useRef(null);
    const [isMuted, setIsMuted] = useState(true);
    const [showSkip, setShowSkip] = useState(false);

    useEffect(() => {
        const videoEl = videoRef.current;

        const handleEnded = () => {
            onVideoEnd();
        };

        if (videoEl) {
            // Try to play with sound first
            videoEl.play().then(() => {
                setIsMuted(false);
                videoEl.muted = false;
            }).catch(err => {
                // Autoplay blocked → mute
                videoEl.muted = true;
                setIsMuted(true);
                videoEl.play().catch(e => console.log("Video play error:", e));
            });

            videoEl.addEventListener("ended", handleEnded);
        }

        // Show skip button after 2 seconds
        const skipTimer = setTimeout(() => setShowSkip(true));

        return () => {
            if (videoEl) videoEl.removeEventListener("ended", handleEnded);
            clearTimeout(skipTimer);
        };
    }, [onVideoEnd]);

    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !isMuted;
            setIsMuted(!isMuted);
        }
    };

    const handleClose = () => {
        onVideoEnd();
    };

    return (
        <div
            className="video-intro-overlay"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.7)", // semi-transparent background
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
            }}
        >
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    // maxWidth: "100%",
                    // aspectRatio: "16/9",
                    backgroundColor: "#000",
                    // borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.5)"
                }}
            >
                <video
                    ref={videoRef}
                    src={videoSrc}
                    playsInline
                    preload="auto"
                    // autoPlay
                    // muted
                    // loop
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // fills screen properly
                    }}
                />

                {/* Skip button */}
                {showSkip && (
                    <button
                        onClick={handleClose}
                        style={{
                            position: "absolute",
                            top: "15px",
                            right: "15px",
                            width: "40px",
                            height: "40px",
                            backgroundColor: "rgba(255,255,255,0.9)",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer",
                            fontSize: "24px",
                            fontWeight: "bold",
                            zIndex: 10000,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
                            transition: "all 0.3s ease",
                            color: "#333"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = "rgba(255,255,255,1)";
                            e.target.style.transform = "scale(1.1) rotate(90deg)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "rgba(255,255,255,0.9)";
                            e.target.style.transform = "scale(1) rotate(0deg)";
                        }}
                    >
                        ×
                    </button>
                )}

                {/* Mute toggle */}
                <button
                    onClick={toggleMute}
                    style={{
                        position: "absolute",
                        bottom: "20px",
                        right: "20px",
                        padding: "10px 20px",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        border: "none",
                        borderRadius: "25px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "600",
                        zIndex: 10000,
                        boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
                        transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "rgba(255,255,255,1)";
                        e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "rgba(255,255,255,0.9)";
                        e.target.style.transform = "scale(1)";
                    }}
                >
                    {isMuted ? "Enable Sound" : "Disable Sound"}
                </button>
            </div>
        </div>
    );
};

const HomePage = () => {
    const [heroData, setHeroData] = useState(null);
    const [showHome, setShowHome] = useState(() => {
        // Check if video has already been shown in this session
        const hasSeenVideo = sessionStorage.getItem('hasSeenIntroVideo');
        return hasSeenVideo === 'true';
    });

    useEffect(() => {
        const fetchHero = async () => {
            try {
                const data = await getHero();
                setHeroData(data);
            } catch (err) {
                console.error("Failed to fetch hero data:", err);
            }
        };
        fetchHero();
    }, []);

    const handleVideoEnd = () => {
        // Mark video as seen for this session
        sessionStorage.setItem('hasSeenIntroVideo', 'true');
        setShowHome(true);
    };

    if (!heroData) return null;

    // Show video first, then home content
    if (!showHome) {
        return <VideoIntro videoSrc={IntroVideo} onVideoEnd={handleVideoEnd} />;
    }

    return (
        <Fragment>
            <Hero heroData={heroData} />
            <Navbar Logo={Logo} hclass={'header-style-1'} />
            <div className="content-below-slider">
                <About abimg={MAAKLOGO} />
                <UpcomingProjects />
                <FunFact />
                <Testimonial />
                <BlogSection />
                <Footer />
            </div>
            <Scrollbar />
        </Fragment>
    );
};

export default HomePage;